import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "checkout__bonuses"
};
var _hoisted_2 = {
    class: "cart-promo",
    open: ""
};
var _hoisted_3 = { class: "cart-promo__top" };
var _hoisted_4 = { class: "cart-promo__cover" };
var _hoisted_5 = { class: "cart-promo__marker" };
var _hoisted_6 = { class: "cart-promo__main" };
var _hoisted_7 = { class: "cart-promo__block" };
var _hoisted_8 = { class: "text" };
var _hoisted_9 = { class: "cart-promo__block" };
var _hoisted_10 = { class: "form-group" };
var _hoisted_11 = { class: "form-field form-field--text form-field--1 form-field--m form-field--primary" };
var _hoisted_12 = ["max"];
var _hoisted_13 = { class: "cart-promo__block" };
var _hoisted_14 = { class: "text" };
import { computed, ref, watch } from 'vue';
import Price from "../../../components/Price.vue";
import Sprite from "../../../components/Sprite.vue";
import { pluralize } from "../../../utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BonusAccountPayment',
    props: {
        accountAmount: {
            type: Number,
            required: true,
        },
        totalSum: {
            type: Number,
            required: true,
        },
        modelValue: {
            type: Number,
            default: null,
        }
    },
    emits: ['update:model-value'],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var maxAmount = computed(function () { return Math.min(props.totalSum, props.accountAmount); });
        var emit = __emit;
        var used = ref(props.modelValue);
        var left = computed(function () { return props.accountAmount - used.value; });
        watch(maxAmount, function (amount) {
            if (amount && used.value && used.value > amount) {
                used.value = amount;
            }
            else {
                // used.value = props.accountAmount;
            }
        });
        watch(used, function (amount) {
            if (typeof amount === 'string') {
                amount = parseInt(amount);
                if (isNaN(amount)) {
                    amount = 0;
                }
            }
            else if (amount === null) {
                amount = 0;
            }
            if (amount > maxAmount.value) {
                used.value = maxAmount.value;
            }
            if (amount <= 0) {
                used.value = null;
            }
            emit('update:model-value', used.value === 0 ? null : used.value);
        });
        function onkeydown(event) {
            if (event.key.length === 1 && !event.key.match(/\d/)) {
                event.preventDefault();
                return false;
            }
        }
        return function (_ctx, _cache) {
            return (__props.accountAmount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("details", _hoisted_2, [
                        _createElementVNode("summary", _hoisted_3, [
                            _createElementVNode("span", _hoisted_4, [
                                _createVNode(Sprite, {
                                    name: "bonus",
                                    size: 32
                                })
                            ]),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "cart-promo__title" }, "Оплата бонусами", -1 /* CACHED */)),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_5, [
                                _createVNode(Sprite, {
                                    name: "arrow-down",
                                    size: 16
                                })
                            ])
                        ]),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _cache[5] || (_cache[5] = _createTextVNode("\n            У вас накоплено ", -1 /* CACHED */)),
                                    _createElementVNode("strong", null, [
                                        _createVNode(Price, {
                                            amount: left.value,
                                            "skip-currency": ""
                                        }, null, 8 /* PROPS */, ["amount"]),
                                        _createTextVNode(" " + _toDisplayString(_unref(pluralize)(left.value, 'бонус', 'бонуса', 'бонусов')), 1 /* TEXT */)
                                    ])
                                ])
                            ]),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            class: "form-control",
                                            placeholder: "Введите кол-во бонусов",
                                            name: "used_bonuses",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((used).value = $event); }),
                                            min: "0",
                                            max: maxAmount.value,
                                            onKeydown: onkeydown
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12), [
                                            [_vModelText, used.value]
                                        ])
                                    ])
                                ])
                            ]),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("button", {
                                        class: "link link--dashed",
                                        type: "button",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) { return (used.value = maxAmount.value); }, ["prevent"]))
                                    }, "Использовать всю сумму")
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
